import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import SearchIcon from '@mui/icons-material/Search'
import { motion } from 'framer-motion'
import DividerBooks from './DividerBooks'
import { useTranslation } from 'react-i18next'
import PageSEO from '../shared/PageSEO'

export default function Books() {
  const { t } = useTranslation()
  const [language, setLanguage] = useState('all')
  const [searchQuery, setSearchQuery] = useState('')

  const handleLanguageChange = (newLanguage) => {
    setLanguage(newLanguage)
  }

  return (
    <>
      <PageSEO 
        title="Books | Hyunjin Jae"
        description="Explore my collection of books on software development, web technologies, and personal growth."
        keywords="books, reading list, software development, web technologies, personal growth"
        tags={['books', 'reading', 'learning']}
      />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'flex-start',
        }}>
          <Box sx={{ 
            mb: 2.5,
            display: 'flex',
            flexDirection: 'row',
            gap: 1.5,
            width: '100%'
          }}>
            <TextField
              size="small"
              fullWidth
              placeholder="Search books..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ fontSize: '1.1rem', color: 'text.secondary' }} />
                  </InputAdornment>
                ),
                sx: {
                  height: '36px',
                  fontSize: '0.8rem',
                  backgroundColor: '#fff',
                  '& input::placeholder': {
                    color: 'text.secondary',
                    opacity: 1
                  }
                }
              }}
              sx={{ 
                width: '50%',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#e0e0e0',
                  },
                  '&:hover fieldset': {
                    borderColor: '#bdbdbd',
                  }
                }
              }}
            />
            <ButtonGroup 
              size="small"
              variant="outlined" 
              aria-label="language filter buttons"
              sx={{ 
                width: '50%',
                height: '36px',
                '& .MuiButton-root': {
                  flex: 1,
                  fontSize: '0.8rem',
                  backgroundColor: '#fff',
                  borderColor: '#e0e0e0',
                  color: 'text.secondary',
                  '&:hover': {
                    borderColor: '#bdbdbd',
                    backgroundColor: '#f5f5f5'
                  },
                  '&.Mui-selected, &.MuiButton-contained': {
                    backgroundColor: '#1976d2',
                    color: '#fff',
                    '&:hover': {
                      backgroundColor: '#1565c0'
                    }
                  }
                }
              }}
            >
              <Button 
                onClick={() => handleLanguageChange('all')}
                variant={language === 'all' ? 'contained' : 'outlined'}
              >
                {t('books:all')}
              </Button>
              <Button 
                onClick={() => handleLanguageChange('kr')}
                variant={language === 'kr' ? 'contained' : 'outlined'}
              >
                {t('books:kr')}
              </Button>
              <Button 
                onClick={() => handleLanguageChange('en')}
                variant={language === 'en' ? 'contained' : 'outlined'}
              >
                {t('books:en')}
              </Button>
            </ButtonGroup>
          </Box>
          
          <DividerBooks selectedLanguage={language} searchQuery={searchQuery} />
        </Box>
      </motion.div>
    </>
  )
}
